module.exports = __webpack_public_path__ + "img/hr-heated-straight-vertical-4.724b7a61.png";